import type { PredefinedPartLabel } from '../types';

const isNumberTriple = (value: unknown): value is [number, number, number] => (
  Array.isArray(value)
  && value.length === 3
  && value.every((item) => typeof item === 'number' && Number.isFinite(item))
);

export const parsePartLabelsJson = (raw: string): PredefinedPartLabel[] => {
  const trimmed = raw.trim();
  if (!trimmed) return [];

  let parsed: unknown;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    throw new Error('部位ラベルJSONを読み取れません');
  }

  const parts = Array.isArray(parsed)
    ? parsed
    : (parsed as { parts?: unknown }).parts;

  if (!Array.isArray(parts)) {
    throw new Error('parts配列、または部位ラベル配列を指定してください');
  }

  return parts.map((part, index) => {
    const item = part as Partial<PredefinedPartLabel>;
    if (
      typeof item.label !== 'string'
      || !item.label.trim()
      || typeof item.category !== 'string'
      || !item.category.trim()
      || !isNumberTriple(item.position)
    ) {
      throw new Error(`部位ラベル${index + 1}の形式が正しくありません`);
    }

    return {
      label: item.label,
      position: item.position,
      category: item.category,
      note: typeof item.note === 'string' ? item.note : null,
    };
  });
};
